module.exports = __webpack_public_path__ + "img/tooFacedPal3.44cb2ee6.jpg";